<!--
  Spinner Component
  Loading indicator with optional label.
-->
<script lang="ts">
  import { _ } from 'svelte-i18n';
  export let size: 'sm' | 'md' | 'lg' = 'md';
  export let label: string | undefined = undefined;
  // Set where the surrounding markup already announces the loading state.
  export let decorative = false;

  const sizeClasses: Record<string, string> = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
  };
</script>

<div
  class="inline-flex flex-col items-center gap-2"
  role={decorative ? undefined : 'status'}
  aria-hidden={decorative ? 'true' : undefined}
>
  <svg
    class="animate-spin text-accent {sizeClasses[size]}"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3"
    ></circle>
    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
    ></path>
  </svg>
  <!-- The status text is the content (not aria-label): live regions announce content, and a visible label is not read twice. -->
  {#if !decorative}
    {#if label}
      <span class="text-sm text-text-secondary">{label}</span>
    {:else}
      <span class="sr-only">{$_('messages.loading')}</span>
    {/if}
  {/if}
</div>
